// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qYY0CwlsaClHhV {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-bottom: var(--ds-space-0, 0);
  line-height: 32px;
}
.qYY0CwlsaClHhV .unjvTupwzQM7VL,
.qYY0CwlsaClHhV .mvG_Yr_vrJRNG7:hover {
  color: var(--dynamic-star);
}
.qYY0CwlsaClHhV .ZJqyOW7Q8iFoUc:hover > .ZJqyOW7Q8iFoUc {
  transform: scale(1.2);
  cursor: pointer;
}
`, ""]);
// Exports
export var boardStarButton = `qYY0CwlsaClHhV`;
export var starred = `unjvTupwzQM7VL`;
export var unstarred = `mvG_Yr_vrJRNG7`;
export var icon = `ZJqyOW7Q8iFoUc`;
export default ___CSS_LOADER_EXPORT___;
